import _ from 'lodash';
import moment from 'moment-timezone';
import markdown from '~/components/markdown/Markdown.vue';
import CreativePreviewScaled from '~/components/creative-preview-scaled/CreativePreviewScaled.vue';
import CustomPreview from '~/components/custom-preview/CustomPreview.vue';
import FileGallery from '~/components/file-gallery/FileGallery.vue';
import CampaignTargetPopup from '~/components/campaign-target-popup/CampaignTargetPopup.vue';

export default {
  data() {
    return {
      index: null,
    };
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    userIcon: {
      type: String,
      default: null,
    },
    created: {
      type: String,
      required: true,
    },
    updated: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    files: {
      type: Array,
      default: () => [],
    },
    preview: {
      type: Object,
      default: null,
    },
    customPreview: {
      type: Object,
      default: null,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    component: {
      type: Object,
      default: null,
    },
  },
  components: {
    markdown,
    FileGallery,
    'creative-preview-scaled': CreativePreviewScaled,
    'custom-preview': CustomPreview,
    CampaignTargetPopup,
  },
  computed: {
    facebookPage() {
      return _.get(this.preview, 'fbpage', null);
    },
  },
  methods: {
    getTimeAgo(timestamp) {
      return moment(timestamp).fromNow();
    },
    getFullDate(timestamp) {
      return this.$t('fn.datetime', { timestamp });
    },
    openImage(imageIndex) {
      this.index = imageIndex;
    },
    removeLinkTag(a, url) {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    downloadImage(url) {
      if (url) {
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const filename = url.split('/').pop();
            if (window.navigator.msSaveBlob) {
              // IE doesn't support download tag
              window.navigator.msSaveBlob(blob, filename);
            } else {
              const a = document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              setTimeout(this.removeLinkTag(a, url), 100);
            }
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/timeline/events/default/Default.js